export default "__VITE_PUBLIC_ASSET__a082d93c__"